<template>
  <v-container class="register-page fill-height">
    <v-row align="center" justify="center" class="fill-height ma-0" no-gutters>
      <v-col cols="12" sm="9" md="7" lg="6" xl="4">
        <v-card class="py-8 px-4 px-sm-8">
          <v-row align="center" justify="center">
            <v-col cols="auto">
              <Logo class="if-logo" />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="mb-6">
            <v-col cols="auto">
              <div class="text-uppercase text-center mb-2">Personal Section</div>
              <div class="text-center">Enter your email and password</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-form ref="form" v-model="valid" action="javascript:void(0);" >
                <!-- <v-text-field outlined v-model="name" required label="Name & Surname" /> -->
                <v-text-field outlined v-model="email" :rules="$root.auth.emailRules" required label="E-Mail" />
                <v-text-field outlined v-model="password" :rules="$root.auth.passwordRules" required counter label="Password" type="password" />
                <v-text-field outlined v-model="repeatPassword" :rules="repeatPasswordRules" required counter label="Repeat Password" type="password" />
                <v-btn block depressed rounded light large :loading="$root.auth.working" type="submit" @click="validate">Sign Up</v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import trim from 'lodash/trim'
import Logo from '@/assets/img/logo.svg'

export default {
  name: 'RegisterPage',
  components: {
    Logo
  },
  data () {
    return {
      repeatPasswordRules: [
        v => !!v || this.$gettext('Repeat the password please'),
        v => (v && v === this.password) || this.$gettext('Passwords must match')
      ],
      // error: null,
      valid: true,
      // name: null,
      email: null,
      password: null,
      repeatPassword: null
    }
  },
  methods: {
    async validate () {
      if (this.$refs.form.validate()) {
        try {
          const data = await this.$root.auth.signup(trim(this.email).toLowerCase(), this.password)
          console.log(data)
          this.$router.replace({ name: 'Onboarding', params: { precompiledEmail: this.email.toLowerCase(), precompiledPassword: this.password } })
        } catch (e) {
          console.error(e)
          // this.error = e.message
        }
      }
    }
  }
}
</script>
